import React, { useState } from 'react'
import { motion } from "framer-motion"

const MenuItem = ({ scene, variants, custom, initial, variation = "right" }) => {

    const [hovered, setHovered] = useState(false);
    const hint = scene.hint;
    scene = scene.scene;
    return (
        <motion.div initial={initial} variants={variants} custom={custom} className={`flex flex-row gap-2 items-stretch ${variation === "left"? "justify-end":""}`} onMouseEnter={() => {
            setHovered(true)
        }} onMouseLeave={() => {
            setHovered(false)
        }} onClick={() => {
            scene.loadScene();
        }}>


            {variation === "right" ?
                <>
                    <motion.div initial={{ backgroundColor: "#374151" }} animate={hovered ? { backgroundColor: "#1f2937" } : {}} transition={{ ease: "easeOut", duration: .2 }} className=' p-[6px] rounded-md'>

                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="white" class="bi bi-eye" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                    </motion.div>
                    <motion.div initial={{ backgroundColor: "#374151" }} animate={hovered ? { backgroundColor: "#1f2937", transform: "translateX(3px)" } : {}} transition={{ ease: "easeOut", duration: .2 }} className='rounded-md text-lg font-bold  px-5 text-white flex items-center'>

                        {hint}

                    </motion.div>
                </>
                :
                <>
                    <motion.div initial={{ backgroundColor: "#374151" }} animate={hovered ? { backgroundColor: "#1f2937", transform: "translateX(3px)" } : {}} transition={{ ease: "easeOut", duration: .2 }} className='rounded-md text-lg font-bold  px-5 text-white flex items-center'>

                        {hint}

                    </motion.div>
                    <motion.div initial={{ backgroundColor: "#374151" }} animate={hovered ? { backgroundColor: "#1f2937" } : {}} transition={{ ease: "easeOut", duration: .2 }} className=' p-[6px] rounded-md'>

                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="white" class="bi bi-eye" viewBox="0 0 16 16">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                    </motion.div>
                </>
            }

        </motion.div>
    )
}

export default MenuItem